import { graphql } from "relay-runtime"

export const chRejectPatientAsPotentialDuplicateMutation = graphql`
  mutation chRejectPatientAsPotentialDuplicateMutation($input: Ch_rejectPatientAsPotentialDuplicateInput!) {
    rejectPatientAsPotentialDuplicate: ch_rejectPatientAsPotentialDuplicate(input: $input) {
      boolean
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`
